import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { TextP, TextSpan } from '../../../Defaults/Text';
import { SvgIcon, IconType } from '../../../Zemplin/General/SvgIcon';

export interface Props {
  theme: any;
  borderBottom?: boolean;
}

function MinAmountInfoText({ theme, borderBottom }: Props) {
  return (
    <Wrapper borderBottom={borderBottom}>
      <SvgIcon
        fill={theme.colors.primary}
        width={24}
        height={24}
        icon={IconType.success}
        alt="info"
        title="info"
        marginRight={16}
      />
      <Text>
        {__('V prípade, že neobjednáte minimálne množstvo v zmysle')}{' '}
        <TermsLink
          target="_blank"
          to={__r('routes:obchodne-podmienky', '/obchodne-podmienky')}
        >
          {__('obchodných podmienok')}
        </TermsLink>
        {', '} {__('bude Vám účtovaný manipulačný poplatok.')}
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)<{ borderBottom?: boolean }>`
  text-decoration: none;
  margin-bottom: 0;
  width: 100%;
  border-radius: ${rem(2)};
  padding: ${rem(12)} ${rem(16)};
  background: ${({ theme }) => theme.colors.navSecondary};
  align-items: flex-start;
  border-bottom: ${({ theme, borderBottom }) =>
    borderBottom ? theme.borders.primary : 'none'};

  ${({ theme }) => theme.mediab.m810`
     margin-top: ${rem(24)};
  `}

  ${({ theme }) => theme.mediab.s450`
      margin: ${rem(24)} -${rem(16)} 0;
      width: calc(100vw - ${rem(16)});
  `}
`;

const Text = styled(TextSpan)`
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.secondaryLight};
  color: ${({ theme }) => theme.colors.primary};
  line-height: ${rem(22)};
  font-weight: 400;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
     font-size: ${rem(13)};
     line-height: ${rem(21)};
  `}
`;

const TermsLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
`;

const withThemeInfoText: any = withTheme(MinAmountInfoText);
export { withThemeInfoText as MinAmountInfoText };
